import React, { useState, useEffect } from "react";
import Toggle from "./../common/customtoggle";

const Carduser = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleChangeToggleCustom,
  handleOnClick,
  handelDelete,
  search,
  onUpdate,
}) => {
  const [checktoogle, setchecktoogle] = useState(true);
  const [isopen, setisopen] = useState(false);
  const [disableSave, setdisableSave] = useState(false);
  const [loading, setLoading] = useState(true);
  const [status, setstatus] = useState(false);
  const [togglepower, settogglepower] = useState(false);
  const [togglepulp, settogglepulp] = useState(false);
  const handleonopen = () => {
    setstatus(true);
  };


  return (
    <>
      {list &&
        list.length > 0 &&
        list.map((item, index) => {
          return (
            <div className="card shadow my-1 " key={index}>
              <div className="row d-flex align-items-center m-1">
                <div className="col-lg-1">
                  <img
                    src={
                      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=" +
                      item.empid
                    }
                    alt="..."
                    className="rounded-circle ml-1 m-1"
                    style={{ maxHeight: 40, maxWidth: 40 }}
                  ></img>
                </div>

                <div className="col-lg-2">
                  {" "}
                  <span className=" ml-1">
                    <i
                      className="fa fa-address-card mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    {item.empid}
                  </span>
                </div>
                <div className="col-lg-4">
                  {" "}
                  <span className=" ml-1">
                    <i
                      className="fa fa-user-circle-o mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    {item.fname} {item.lname}
                  </span>
                </div>

               { <div
                  className="col-lg-3"
                >
                  <Toggle
                    name={index + "power"}
                    checked={item.power}
                    onChange={() =>
                      handleChangeToggleCustom(item.empid, "power", item.power)
                    }
                    text="สิทธิกลุ่ม Power"
                    disabled={false}
                  />

                  <Toggle
                    name={index + "pulp"}
                    checked={item.pulp}
                    disabled={false}
                    onChange={() =>
                      handleChangeToggleCustom(item.empid, "pulp", item.pulp)
                    }
                    text="สิทธิกลุ่ม Non Power"
                  />
                </div>}

                <div className="col-lg-2 d-flex justify-content-end  ">
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    //disabled={disableSave || loading}
                    onClick={() =>
                      handleOnClick([item.empid, item.power, item.pulp])
                    }
                  >
                    ADD
                  </button>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default Carduser;
